<template>
  <div class="box">
    <h3 class="title is-4">Patient Verifier</h3>
    <div class="content">
      <p>
        Search for matching patient records and review their names, dates of birth, SSNs, and
        addresses before continuing to a Blanket VOB search.
      </p>
      <h4>How it works:</h4>
      <ul>
        <li>Start with a last name. Other patient and address fields are optional.</li>
        <li>
          <strong>More information helps narrow the results and improve match accuracy.</strong>
          Add a first name, date of birth, SSN, or address when available.
        </li>
        <li>Review each result and its match score to identify the correct patient.</li>
        <li>
          Select
          <strong>Rerun as Blanket VOB</strong>
          to open a form with that patient's details prefilled. Choose a provider, review the
          information, and submit when ready.
        </li>
      </ul>
      <p>
        Each submitted search uses one verification from your subscription allowance. Opening saved
        results does not use another verification.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PatientVerificationFeatureDetail',
};
</script>

<style scoped>
.content h4 {
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
  font-weight: 600;
}
.content ul {
  margin-top: 0.5rem;
}
.content li {
  margin-bottom: 0.5rem;
}
</style>
